import $ from "../$.js";
import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as websocket from "../util/websocket.js";
 
  var 
    datas = {};

  amplify.subscribe("familyScopeChange",function(){
    datas = {};
  });
  amplify.subscribe("notificationBullet",function(key,value){
    if(datas[key]!==value){
      datas[key]=value;
      $('*[data-notification-key="'+key+'"]').html(value)[value?'fadeIn':'fadeOut']();
    }
  });
  amplify.subscribe("notificationBulletDelta",function(key,value){
    amplify.publish("notificationBullet",key,datas[key] + value);
  });
  websocket.subscribe('New_Message',function(msg){
    var 
      displayedThread = $("#thread-pane [data-fw-meta-id='"+msg.push.targetId+"']"),
      threadInList = $(".fw-thread[data-fw-meta-id='"+msg.push.targetId+"']");
    if(displayedThread.length){
      amplify.publish("refreshThreadMessages",msg.push.targetId);
    }else if(threadInList.length){  
      threadInList.find('.fw-notification').fadeIn();
    }else{
      amplify.publish("notificationBulletDelta","imunreadthread",1);
    }
  })
  
function init(obj){
  var key = obj.attr('data-notification-key');
  if(datas[key]){
    obj.html(datas[key]).show();
  }else{
    obj.html(datas[key]).hide();
  }
}
function get(key){
  return datas[key];
}
    
Html.registerWidget('widget/notification-bullet',{init:init})
  
export {init,get};